export const facultiesArray = [
    {
      facultyId: 1,
      name: "Faculty of Computing",
      intro: <>Lorem Ipsum</>,
    },
    {
      facultyId: 2,
      name: "Faculty of Management and Social Sciences",
      intro: <>Lorem Ipsum</>,
    },
    {
      facultyId: 3,
      name: "Faculty of Life Sciences",
      intro: <>Lorem Ipsum</>,
    },
    {
      facultyId: 4,
      name: "Faculty of Sciences",
      intro: <>Lorem Ipsum</>,
    },
    {
      facultyId: 5,
      name: "Faculty of Education",
      intro: <>Lorem Ipsum</>,
    },
    {
      facultyId: 6,
      name: "Faculty of Allied Health Sciences",
      intro: <>Lorem Ipsum</>,
    },
    {
      facultyId: 7,
      name: "Institute of Environmental and Agricultural Sciences",
      intro: <>Lorem Ipsum</>,
    },
  
  ];
  export const departmentsArray = [
    {
      deptId: 101,
      name: "Department of Computer Science & IT",
      facultyId: 1,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 102,
      name: "Department of Software Engineering",
      facultyId: 1,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 103,
      name: "Department of Information Technology",
      facultyId: 1,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 104,
      name: "Department of Data Science",
      facultyId: 1,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 201,
      name: "Institute Of Social And Cultural Studies",
      facultyId: 2,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 202,
      name: "Department Of Sociology",
      facultyId: 2,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 203,
      name: "Department Of Media & Communication Studies",
      facultyId: 2,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 204,
      name: "School Of Law",
      facultyId: 2,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 205,
      name: "Centre For English Language And Learning",
      facultyId: 2,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 206,
      name: "Department Of Fine Arts",
      facultyId: 2,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 207,
      name: "Department Of Commerce",
      facultyId: 2,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 208,
      name: "Department Of Economics",
      facultyId: 2,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 209,
      name: "Department Of Urdu",
      facultyId: 2,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 210,
      name: "Department Of Islamic Studies",
      facultyId: 2,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 211,
      name: "Department Of Banking And Finance",
      facultyId: 2,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 212,
      name: "Department Of Political Science",
      facultyId: 2,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 213,
      name: "Department Of International Relations",
      facultyId: 2,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 214,
      name: "Department Of Social Work",
      facultyId: 2,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 215,
      name: "Department Of Library And Information Sciences",
      facultyId: 2,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 216,
      name: "Department Of Management Sciences",
      facultyId: 2,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 217,
      name: "Department Of English Linguistics",
      facultyId: 2,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 218,
      name: "Department Of Anthropology",
      facultyId: 2,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 219,
      name: "Department Of English Literature",
      facultyId: 2,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 301,
      name: "Institute Of Pure & Applied Zoology",
      facultyId: 3,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 302,
      name: "Department Of Biochemistry",
      facultyId: 3,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 303,
      name: "Department Of Biology",
      facultyId: 3,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 304,
      name: "Department Of Molecular Biology",
      facultyId: 3,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 305,
      name: "Department Of Zoology",
      facultyId: 3,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 306,
      name: "Department Of Fisheries And Aquaculture",
      facultyId: 3,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 307,
      name: "Department Of Wildlife & Ecology",
      facultyId: 3,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 308,
      name: "Department Of Genetics",
      facultyId: 3,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 309,
      name: "School Of Applied Biology",
      facultyId: 3,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 310,
      name: "Department Of Bioinformatics",
      facultyId: 3,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 311,
      name: "Department Of Biotechnology",
      facultyId: 3,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 312,
      name: "Department Of Microbiology & Molecular Genetics",
      facultyId: 3,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 313,
      name: "Department Of Botany",
      facultyId: 3,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 314,
      name: "Department Of Home Economics",
      facultyId: 3,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 315,
      name: "Department Of Geography",
      facultyId: 3,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 316,
      name: "Computational Physics",
      facultyId: 3,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 401,
      name: "Department Of Chemistry",
      facultyId: 4,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 402,
      name: "Department Of Physics",
      facultyId: 4,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 403,
      name: "Department Of Mathematics",
      facultyId: 4,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 404,
      name: "Department Of Statistics",
      facultyId: 4,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 405,
      name: "Centre For Nanosciences",
      facultyId: 4,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 501,
      name: "Department Of Science Education",
      facultyId: 5,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 502,
      name: "Department Of Teacher Education",
      facultyId: 5,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 503,
      name: "Department Of Educational Research & Assessment",
      facultyId: 5,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 504,
      name: "Department Of Special Education",
      facultyId: 5,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 505,
      name: "Center Of Skill Development",
      facultyId: 5,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 506,
      name: "Department Of Educational Studies",
      facultyId: 5,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 507,
      name: "Department Of Educational Planning And Management (EPM)",
      facultyId: 5,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 508,
      name: "Department Of Early Childhood Education",
      facultyId: 5,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 601,
      name: "Department Of Psychology",
      facultyId: 6,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 602,
      name: "Department Of Public Health",
      facultyId: 6,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 603,
      name: "Department Of Sports Sciences And Physical Education",
      facultyId: 6,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 701,
      name: "Department Of Environmental Sciences",
      facultyId: 7,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 702,
      name: "Department Of Agricultural Sciences",
      facultyId: 7,
      intro: <>Lorem ipsum</>,
    },
    {
      deptId: 703,
      name: "Department Of Sustainability",
      facultyId: 7,
      intro: <>Lorem ipsum</>,
    },
  ];

  export const prefixArray =[
    "Professor",
    "Assistant Professor",
    "Associate Professor",
    "Lecturer",
    "Visiting Faculty"
  ];

  export const designationArray = [
    "Dean",
    "Professor",
    "Associate Professor",
    "Assistant Professor",
    "Lecturer",
  ];
